import React, { ComponentPropsWithoutRef } from 'react';
import { Typography, TTypographyProps } from '@rbx/ui';

export type ListItemProps = ComponentPropsWithoutRef<'li'> & {
  typographyProps?: TTypographyProps;
};

export default function MarkdownListItem({
  children,
  typographyProps,
  ...otherProps
}: ListItemProps) {
  return (
    <li {...otherProps}>
      <Typography paragraph component='div' {...typographyProps}>
        {children}
      </Typography>
    </li>
  );
}
